"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _component = _interopRequireDefault(require("../base/component"));

var _component2 = require("../../components/base/component");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var emptyFunc = function emptyFunc() {};

var getCurrentRange = function getCurrentRange() {
  var sel = window.getSelection();

  if (sel.getRangeAt && sel.rangeCount) {
    return sel.getRangeAt(0);
  }
};

var initRange = function initRange(dom) {
  var range = document.createRange();
  var endOffset = dom.childNodes.length;
  range.setStart(dom, endOffset);
  range.setEnd(dom, endOffset);
  return range;
};

var focusRange = function focusRange(range) {
  var selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
};

var insetHTML = function insetHTML(selectRange, htmlStr) {
  // string to frag
  var temp = document.createElement('template');
  temp.innerHTML = htmlStr;
  var frag = temp.content; // dom

  selectRange.deleteContents();
  selectRange.insertNode(frag); // set selectRange

  selectRange.collapse();
  focusRange(selectRange);
};

var RichTextEditor = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(RichTextEditor, _KZUIComponent);

  var _super = _createSuper(RichTextEditor);

  function RichTextEditor(props) {
    var _this;

    _classCallCheck(this, RichTextEditor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "wrp", void 0);

    _defineProperty(_assertThisInitialized(_this), "selectedRange", void 0);

    _defineProperty(_assertThisInitialized(_this), "lastHtml", void 0);

    _defineProperty(_assertThisInitialized(_this), "commander", void 0);

    _this.autoBind('handleBlur', 'commander', 'handleChange', 'handleKeyPress', 'handlePaste', 'handleFocus');

    return _this;
  }

  _createClass(RichTextEditor, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.value !== this.props.value || nextProps.className !== this.props.className;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var wrp = this.wrp; // init range

      this.selectedRange = initRange(wrp);
      var afterInit = this.props.afterInit;

      this.commander = function (name, args) {
        var selectRange;
        var currentRange = getCurrentRange();

        if (currentRange && wrp.contains(currentRange.commonAncestorContainer)) {
          selectRange = currentRange;
        } else {
          selectRange = _this2.selectedRange;
        }

        switch (name) {
          case 'INSERT_HTML':
            {
              // 在这里操作DOM
              var html = args.html;
              insetHTML(selectRange, html); // 触发change事件

              _this2.handleChange();

              break;
            }

          case 'GET_HTML':
            {
              if (typeof args !== 'function') return;
              args(wrp.innerHTML);
              break;
            }

          case 'CLEAR_HTML':
            {
              wrp.innerHTML = ''; // 触发change事件

              _this2.handleChange();

              break;
            }

          default:
        }
      };

      afterInit(this.commander, this.wrp);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      // 保存光标位置信息
      this.selectedRange = getCurrentRange();
      this.props.onBlur(e, this.selectedRange);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props$onKeyPres, _this$props;

      var lineBreak = this.props.lineBreak;

      if (e.charCode === 13) {
        lineBreak === 1 && insetHTML(getCurrentRange(), '<br>');
        e.preventDefault();
      }

      if (e.ctrlKey && e.charCode === 13) {
        lineBreak === 0 && insetHTML(getCurrentRange(), '<br>');
        e.preventDefault();
      }

      this.handleChange();
      (_this$props$onKeyPres = (_this$props = this.props).onKeyPress) === null || _this$props$onKeyPres === void 0 ? void 0 : _this$props$onKeyPres.call(_this$props, e);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var wrp = this.wrp;
      var name = this.props.name;
      var html = wrp.innerHTML;

      if (html !== this.lastHtml) {
        var _this$props$onChange, _this$props2;

        (_this$props$onChange = (_this$props2 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props2, {
          name: name,
          value: html
        });
      }

      this.lastHtml = html;
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(e) {
      var _this$props$onPaste, _this$props3;

      (_this$props$onPaste = (_this$props3 = this.props).onPaste) === null || _this$props$onPaste === void 0 ? void 0 : _this$props$onPaste.call(_this$props3, e);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var _this$props$onFocus, _this$props4;

      (_this$props$onFocus = (_this$props4 = this.props).onFocus) === null || _this$props$onFocus === void 0 ? void 0 : _this$props$onFocus.call(_this$props4, e);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "richtext-editor ".concat(this.props.className),
        style: this.props.style,
        ref: this.storeRef('wrp'),
        contentEditable: true,
        onFocus: this.handleFocus,
        dangerouslySetInnerHTML: {
          __html: this.props.value
        },
        onBlur: this.handleBlur,
        onInput: this.handleChange,
        onPaste: this.handlePaste,
        onKeyPress: this.handleKeyPress,
        onMouseUp: this.props.onMouseUp
      });
    }
  }]);

  return RichTextEditor;
}(_component["default"]);

_defineProperty(RichTextEditor, "defaultProps", _objectSpread(_objectSpread({}, _component2.baseDefaultProps), {}, {
  name: '',
  value: '',
  afterInit: emptyFunc,
  onChange: emptyFunc,
  onKeyPress: emptyFunc,
  onPaste: emptyFunc,
  onBlur: emptyFunc,
  onMouseUp: emptyFunc,
  onFocus: emptyFunc,
  lineBreak: 0 // 0 Crtl+Enter换行， 1 Enter换行

}));

var _default = RichTextEditor;
exports["default"] = _default;